// extracted by mini-css-extract-plugin
module.exports = {"wrap":"SaveSearchBtn_wrap__TZ_no"};